import * as actionTypes from "../actions/invitations/actionTypes";

const acceptInvitation = (
  state = {
    invitation: {},
    checkInvitationTokenStart: false,
    checkInvitationTokenFailure: false,
    checkInvitationTokenFailureMessage: "",
    checkInvitationTokenSuccess: false,
    acceptInvitationStart: false,
    acceptInvitationFailure: false,
    acceptInvitationFailureMessage: "",
    acceptInvitationSuccess: false
  },
  { type, payload }
) => {
  switch (type) {
    case actionTypes.SET_INVITATION_TOKEN:
      return Object.assign({}, state, {
        RegistryToken: payload
      });
    case actionTypes.INVITATION_TOKEN_CHECK_START:
      return Object.assign({}, state, {
        invitation: {},
        checkInvitationTokenFailure: false,
        checkInvitationTokenFailureMessage: "",
        checkInvitationTokenSuccess: false,
        checkInvitationTokenStart: true
      });
    case actionTypes.INVITATION_TOKEN_CHECK_SUCCESS:
      return Object.assign({}, state, {
        invitation: payload.invitation,
        checkInvitationTokenFailure: false,
        checkInvitationTokenFailureMessage: "",
        checkInvitationTokenSuccess: true,
        checkInvitationTokenStart: false
      });
    case actionTypes.INVITATION_TOKEN_CHECK_FAILURE:
      return Object.assign({}, state, {
        invitation: {},
        checkInvitationTokenFailure: true,
        checkInvitationTokenFailureMessage: payload,
        checkInvitationTokenSuccess: false,
        checkInvitationTokenStart: false
      });
    case actionTypes.USER_INVITE_CONFIRM_START:
      return Object.assign({}, state, {
        acceptInvitationFailure: false,
        acceptInvitationFailureMessage: "",
        acceptInvitationFailureSuccess: false,
        acceptInvitationStart: true
      });
    case actionTypes.USER_INVITE_CONFIRM_SUCCESS:
      return Object.assign({}, state, {
        acceptInvitationFailure: false,
        acceptInvitationFailureMessage: "",
        acceptInvitationSuccess: true,
        acceptInvitationStart: false
      });
    case actionTypes.USER_INVITE_CONFIRM_FAILURE:
      return Object.assign({}, state, {
        acceptInvitationFailure: true,
        acceptInvitationFailureMessage: payload,
        acceptInvitationdSuccess: false,
        acceptInvitationStart: false
      });

    default:
      return state;
  }
};

export default acceptInvitation;
